<!-- components/AppHeader.vue -->
<template>
  <header class="app-header">
    <div class="app-header__left">
      <button 
        class="app-header__menu-toggle"
        @click="toggleMobileSidebar"
      >
        <i class="fas fa-bars"></i>
      </button>
      
      <!-- <h1 class="app-header__title">{{ currentPageTitle }}</h1> -->
    </div>
    
    <div class="app-header__right">
      
      
      <div class="app-header__user">
        
        <span class="app-header__user-name">欢迎您：{{user?.name}}</span>
      </div>
       <div class="app-header__user">
        <button class="app-header__password" type="text" @click="changepassword">修改密码</button>
      </div>
      <div class="app-header__user">
        <button class="app-header__exit" type="text" @click="logoutsystem">退出登录</button>

      </div>
    </div>
  </header>
  <el-dialog v-if="authStore.isLoggedIn" v-model="userpasswordDialogVisible" title="修改密码" width="300px">
    <el-form :model="userpasdForm" :rules="userpasdRules" ref="userpasdFormRef" label-width="80px">
      <el-form-item label="密码" prop="password">
        <el-input 
          v-model="userpasdForm.password" 
          type="password" 
          placeholder="请输入密码" 
        />
      </el-form-item>
      <!-- 修正确认密码字段 -->
      <el-form-item label="确认密码" prop="repassword">
        <el-input 
          v-model="userpasdForm.repassword" 
          type="password" 
          placeholder="请再次输入密码" 
        />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="userpasswordDialogVisible = false">取消</el-button>
      <el-button type="primary" @click="handlePasswordChange">确定</el-button>
    </template>
  </el-dialog>
</template>


<script setup>
import { computed ,ref,reactive} from 'vue'
import { useAppStore,useAuthStore } from '@/stores/auth'
import { useRouter } from 'vue-router'
import { ElMessageBox ,ElMessage} from 'element-plus'
import {api} from '../utils/request'





const appStore = useAppStore()
const authStore = useAuthStore()
const router = useRouter()
const user = computed(() => authStore.user)
const userpasswordDialogVisible = ref(false)
const userpasdFormRef = ref()
const userpasdRules = {
  password: [
    { required: true, message: '请输入密码', trigger: 'blur' },
    { min: 6, message: '密码长度至少6个字符', trigger: 'blur' }
  ],
  repassword: [
    { required: true, message: '请再次输入密码', trigger: 'blur' },
    { 
      validator: (rule, value, callback) => {
        if (value !== userpasdForm.password) {
          callback(new Error('两次输入的密码不一致'))
        } else {
          callback()
        }
      },
      trigger: 'blur'
    }
  ]
}

const logoutsystem= async () => {
  try {
    await ElMessageBox.confirm('确定要退出登录吗？', '提示', {
      type: 'warning'
    })
    authStore.logout()
    router.push('/login')
  } catch {
    // 用户取消
  }
}
const userpasdForm = reactive({
  
  password: '',
  repassword: '',
})
// 添加修改密码处理函数
const handlePasswordChange = async () => {
  try {
    const valid = await userpasdFormRef.value.validate()
    if (valid) {
      // 这里添加实际的密码修改逻辑
      const updateData = { ...userpasdForm ,id: user.value.id}
      await api.post(`/api/user/updatepasswd`, updateData)

      ElMessage.success('密码修改成功')
      userpasswordDialogVisible.value = false
      // 重置表单
      userpasdForm.password = ''
      userpasdForm.repassword = ''
    }
  } catch (error) {
    console.error('表单验证失败:', error)
  }
}

const changepassword = async () => {
  console.log('修改密码',user.value)
  userpasswordDialogVisible.value = true
}

const toggleMobileSidebar = () => {
  appStore.toggleMobileSidebar()
}
</script>

<style scoped>
.app-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 30px;
  margin-left: 220px; /* 与 app__main 的 margin-left 一致 */
  
  
  position: sticky;
  top: 0;
  z-index: 100;
  width: calc(100% - 220px); /* 与 app__main 的 width 一致 */
  box-sizing: border-box; /* 确保 padding 包含在 width 内 */
}

.app-header__left {
  display: flex;
  align-items: center;
  gap: 220px;
}

.app-header__menu-toggle {
  display: none;
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
  padding: 8px;
  border-radius: 4px;
  transition: background 0.2s;
}

.app-header__menu-toggle:hover {
  background: #f5f5f5;
}

.app-header__title {
  font-size: 24px;
  font-weight: 600;
  color: #2c3e50;
  margin: 0;
}

.app-header__right {
  display: flex;
  align-items: center;
  gap: 20px;
}

.app-header__actions {
  display: flex;
  gap: 10px;
}

.app-header__action {
  position: relative;
  background: none;
  border: none;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
  color: #555;
}

.app-header__action:hover {
  background: #f5f5f5;
}

.app-header__badge {
  position: absolute;
  top: -2px;
  right: -2px;
  background: #e74c3c;
  color: white;
  font-size: 10px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.app-header__user {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  border-radius: 20px;
  cursor: pointer;
  transition: background 0.2s;
}

.app-header__user:hover {
  background: #556af4;
}
.app-header__password:hover {
  background: #01e501;
}
.app-header__exit:hover {
  color: rgb(19, 19, 199);
}


.app-header__user-name {
  font-weight: 500;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .app-header {
    padding: 0 20px;
     width: calc(100% - 20px);
  }

  .app-header__menu-toggle {
    display: flex;
  }

  .app-header__user-name {
    display: none;
  }
}
</style>